import { type RouteRecordRaw } from "vue-router";

import { APP_ROUTES } from "@/Generated/Routes/paths";
import { buildBeforeEnterChain, initWSGuard } from "@/Router/guards";

import professionalRoutes from "./Professional";

export default [
  {
    ...APP_ROUTES.chat.root,
    components: {
      main: () => import("@/Views/chat/index.vue"),
      sidebar: () => import("@/Components/layout/SidebarLayout.vue"),
    },
    beforeEnter: buildBeforeEnterChain(initWSGuard),
    meta: { sidebar: false, drawer: true },
    children: [
      {
        ...APP_ROUTES.chat.assignments.root,
        meta: {
          i18nTitle: "chat.assignment.pool.title",
          sidebar: true,
        },
        component: () => import("@/Views/chat/assignments/index.vue"),
      },

      ...professionalRoutes,
    ],
  },
] as RouteRecordRaw[];
